export enum FormFieldType {
  TIME = 'TIME',
  FULL_DATE = 'FULL_DATE',
  YEAR_AND_MONTH = 'YEAR_AND_MONTH',
  YEAR = 'YEAR',
  INPUT_TEXT = 'INPUT_TEXT',
  INPUT_PHONE = 'INPUT_PHONE',
  INPUT_EMAIL = 'INPUT_EMAIL',
  INPUT_NUMBER = 'INPUT_NUMBER',
  TEXTAREA = 'TEXTAREA',
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
  PERIOD = 'PERIOD',
  DROPDOWN_SINGLE = 'DROPDOWN_SINGLE',
  FILE_UPLOAD = 'FILE_UPLOAD',
  USER_DROPDOWN_MULTI = 'USER_DROPDOWN_MULTI',
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  RADIO_BUTTON_GROUP = 'RADIO_BUTTON_GROUP',
  BUSINESS_OBJECT = 'BUSINESS_OBJECT',
  TAB_GROUP = 'TAB_GROUP'
}
